import { m as motion } from "framer-motion";
import { useAnimateFadeIn } from "../../../animation/animation";
import styles from "./attention-message.module.less";

export type TStatusType = "neutral" | "important";

export type TAttentionMessageProps = {
  text: string;
  status?: TStatusType;
};

const AttentionMessage = ({ text, status = "neutral" }: TAttentionMessageProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <motion.section {...fadeInAnimation} className={[styles.wrapper, styles[status]].join(" ")}>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
    </motion.section>
  );
};

export default AttentionMessage;
